var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "detailsModal",
      attrs: {
        id: "bv-modal-log-details",
        "hide-footer": "",
        "hide-header-close": false,
        "no-close-on-backdrop": false,
        "no-close-on-esc": false,
        centered: "",
        size: _vm.fromHistory ? "lg" : "xl",
        "modal-class": _vm.fromHistory ? "details-modal-from-history" : "",
        "content-class": "details-modal-wrapper",
      },
      on: { hidden: _vm.onHidden },
      scopedSlots: _vm._u([
        {
          key: "modal-title",
          fn: function () {
            return [
              _c("div", { staticClass: "modal-title-text" }, [
                _vm._v(_vm._s(_vm.$t("resumodacopia"))),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm.log || _vm.isMultiProcessMode
        ? _c(
            "div",
            { staticClass: "details-modal-content" },
            [
              _vm.fromHistory
                ? [
                    _c("div", { staticClass: "origin-destination-card" }, [
                      _c(
                        "div",
                        { staticClass: "origin-destination-row" },
                        [
                          _c(
                            "b-badge",
                            {
                              staticClass: "origin-badge",
                              attrs: { variant: "success" },
                            },
                            [_vm._v(_vm._s(_vm.$t("origem")))]
                          ),
                          _c("span", { staticClass: "client-name" }, [
                            _vm._v(_vm._s(_vm.clientOriginName)),
                          ]),
                          _c("b-icon", {
                            staticClass: "arrow-icon",
                            attrs: { icon: "arrow-right" },
                          }),
                          _c(
                            "b-badge",
                            {
                              staticClass: "destination-badge",
                              attrs: { variant: "info" },
                            },
                            [_vm._v(_vm._s(_vm.$t("destino")))]
                          ),
                          _c("span", { staticClass: "client-name" }, [
                            _vm._v(_vm._s(_vm.clientDestinationName)),
                          ]),
                        ],
                        1
                      ),
                    ]),
                    !_vm.isLogError
                      ? _c(
                          "div",
                          { staticClass: "summary-section" },
                          [
                            _c("CopySummaryCollapses", {
                              attrs: {
                                "created-count": _vm.resultsCreated,
                                "substituted-count": _vm.resultsSubstituted,
                                "ignored-count": _vm.resultsIgnored,
                                "deleted-count": _vm.resultsDeleted,
                                "created-items": _vm.createdItems,
                                "substituted-items": _vm.substitutedItems,
                                "ignored-items": _vm.ignoredItems,
                                "deleted-items": _vm.deletedItems,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.isLogError
                      ? _c(
                          "div",
                          { staticClass: "error-section" },
                          [
                            _c(
                              "b-alert",
                              {
                                staticClass: "mb-0",
                                attrs: { show: "", variant: "danger" },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-items-center" },
                                  [
                                    _c("b-icon", {
                                      staticClass: "mr-2",
                                      attrs: {
                                        icon: "exclamation-triangle-fill",
                                      },
                                    }),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("copiafalhou"))),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "button-container" },
                      [
                        !_vm.isLogError
                          ? _c(
                              "b-button",
                              {
                                staticStyle: { "margin-right": "15px" },
                                attrs: { variant: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.downloadLogSummary()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("baixarresumo")) + " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "outline-secondary" },
                            on: { click: _vm.hide },
                          },
                          [_vm._v(_vm._s(_vm.$t("fechar")))]
                        ),
                      ],
                      1
                    ),
                  ]
                : [
                    _c(
                      "div",
                      { staticClass: "results-table-container" },
                      [
                        _c("DMPaginatedTable", {
                          attrs: {
                            fields: _vm.summaryTableFields,
                            data: _vm.summaryRows,
                            "show-pagination": false,
                            "show-action-buttons": false,
                            "show-update-buttom": false,
                            "show-delete-buttom": false,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "cell(scope)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "scope-badges" },
                                      [
                                        _vm._l(
                                          data.value,
                                          function (scopeItem, index) {
                                            return _c(
                                              "b-badge",
                                              {
                                                key: `${data.item.id}-${index}`,
                                                staticClass: "scope-badge",
                                                attrs: { variant: "secondary" },
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(scopeItem) + " "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        !data.value || data.value.length === 0
                                          ? _c("span", [_vm._v("-")])
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(status)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "b-badge",
                                      {
                                        staticClass: "table-status-badge",
                                        attrs: {
                                          variant: _vm.getSummaryStatusVariant(
                                            data.value
                                          ),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.getSummaryStatusLabel(
                                                data.value
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            937424362
                          ),
                        }),
                      ],
                      1
                    ),
                    _vm.isMultiProcessMode && _vm.isProcessing
                      ? _c(
                          "div",
                          { staticClass: "process-status-list" },
                          _vm._l(_vm.processingProcesses, function (process) {
                            return _c(
                              "div",
                              {
                                key: process.room,
                                staticClass: "process-status-item",
                              },
                              [
                                _c("span", { staticClass: "process-module" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getSourceModuleLabel(
                                        process.sourceModule
                                      )
                                    )
                                  ),
                                ]),
                                _c("span", { staticClass: "process-message" }, [
                                  _vm._v(
                                    _vm._s(_vm.getProcessMessage(process))
                                  ),
                                ]),
                                _c("b-progress", {
                                  staticClass: "mt-2",
                                  attrs: {
                                    value: process.progress,
                                    variant: "success",
                                    height: "1rem",
                                    animated: "",
                                  },
                                }),
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm.allCompleted && (!_vm.hasError || _vm.hasPartialSuccess)
                      ? _c(
                          "div",
                          { staticClass: "summary-section" },
                          [
                            _c("CopySummaryCollapses", {
                              attrs: {
                                "created-count": _vm.resultsCreated,
                                "substituted-count": _vm.resultsSubstituted,
                                "ignored-count": _vm.resultsIgnored,
                                "deleted-count": _vm.resultsDeleted,
                                "created-items": _vm.createdItems,
                                "substituted-items": _vm.substitutedItems,
                                "ignored-items": _vm.ignoredItems,
                                "deleted-items": _vm.deletedItems,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.allCompleted && _vm.hasError && !_vm.hasPartialSuccess
                      ? _c("div", { staticClass: "error-section" }, [
                          _c("div", { staticClass: "error-summary-card" }, [
                            _c("div", { staticClass: "error-card-header" }, [
                              _c(
                                "div",
                                { staticClass: "summary-header" },
                                [
                                  _c("b-icon", {
                                    staticClass: "info-icon",
                                    attrs: { icon: "info-circle" },
                                  }),
                                  _c("span", { staticClass: "summary-title" }, [
                                    _vm._v(_vm._s(_vm.$t("resumodacopia"))),
                                  ]),
                                ],
                                1
                              ),
                              _c("p", { staticClass: "summary-description" }, [
                                _vm._v(_vm._s(_vm.$t("visualizacaorapida"))),
                              ]),
                            ]),
                            _c("div", { staticClass: "error-state-content" }, [
                              _c(
                                "div",
                                { staticClass: "error-icon-wrapper" },
                                [
                                  _c("b-icon", {
                                    staticClass: "error-icon-x-circle",
                                    attrs: { icon: "x-circle" },
                                  }),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "error-state-title" }, [
                                _vm._v(_vm._s(_vm.$t("importante"))),
                              ]),
                              _c(
                                "div",
                                { staticClass: "error-state-message" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("copysummaryerrorstatus")) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _vm.allCompleted
                      ? _c(
                          "div",
                          { staticClass: "button-container" },
                          [
                            !_vm.hasError || _vm.hasPartialSuccess
                              ? _c(
                                  "b-button",
                                  {
                                    staticStyle: { "margin-right": "15px" },
                                    attrs: { variant: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.downloadLogSummary()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("baixarresumo")) + " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  variant:
                                    _vm.hasError && !_vm.hasPartialSuccess
                                      ? "primary"
                                      : "outline-secondary",
                                },
                                on: { click: _vm.hide },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.hasError && !_vm.hasPartialSuccess
                                        ? _vm.$t("ok")
                                        : _vm.$t("fechar")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("CopyResultToastModal", { ref: "copyResultToast" }),
                  ],
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }